import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { GET_SUBJECTS } from "actions/subjects";

const loadingSubjects = (state = initialState.loadingSubjects, action: any) => {
  switch (action.type) {
    case pending(GET_SUBJECTS):
      return true;
    case fulfilled(GET_SUBJECTS):
    case failed(GET_SUBJECTS):
      return false;
    default:
      return state;
  }
};

export default loadingSubjects;
